import Vue from 'vue'

const TYPES = {
  error:'error',
  success:'success'
}

export default class HttpService{
  constructor() {
    this.$http = Vue.http;
    this._headers = {'Content-Type': 'application/json'};
    this.types = TYPES;
  }

  _post(url,data,headers){
    let h = (!headers) ? this._headers : headers;
   return this.$http.post(url,data,{headers:h})
      .then(res => res.json());
  }

  _get(url,data){
    this.$http.get(url,data,{headers:this._headers})
      .then(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/services/HttpService.js